import axios from 'axios';

export const EVENTS_PLATFORM_API_URL = process.env.VUE_APP_EVENTS_PLATFORM_API_URL;
export const COMMON_REPORT_API_URL = process.env.VUE_APP_COMMON_REPORT_API_URL;
export const EVENTS_SURVEYS_API_URL = process.env.VUE_APP_EVENTS_SURVEYS_API_URL;

export function fetchEvents() {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/events`,
    method: 'GET',
  }).then((response) => response.data);
}

export function searchEventUser(input, id) {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/events/${id}/user?q=${input}`,
    method: 'GET',
  }).then(
    (response) => response.data,
  );
}

export function saveEventUser({ eventUser, eventId }) {
  return axios({
    method: 'POST',
    url: `${EVENTS_PLATFORM_API_URL}/events/${eventId}/user`,
    data: eventUser,
  }).then((response) => response.data);
}

export function deleteEventUser({ eventUserId, eventId, eventUser }) {
  return axios({
    method: 'DELETE',
    url: `${EVENTS_PLATFORM_API_URL}/events/${eventId}/user/${eventUserId}`,
    // se utiliza solo para obtener y mostrar el user que nos da error al eliminar
    data: eventUser,
  }).then((response) => response.data);
}

export async function saveEvent(event) {
  return axios({
    method: 'POST',
    url: `${EVENTS_PLATFORM_API_URL}/events`,
    data: { ...event },
  }).then((response) => response.data);
}

export function fetchEventUsers({ eventId }) {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/events/${eventId}/users`,
    method: 'GET',
  }).then((response) => response.data);
}

export function fetchEvent(id) {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/events/${id}`,
    method: 'GET',
  }).then((response) => response.data);
}

export function fetchUserFieldTypes() {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/events/user-field-types`,
    method: 'GET',
  }).then((response) => response.data);
}

export async function downloadCheckIn({ eventId, eventUser }) {
  return axios(`${COMMON_REPORT_API_URL}/`, {
    method: 'POST',
    params: {
      id: `EVENTS_PLATFORM_CHECKIN_${eventId}`,
    },
    data: {
      data: { ...eventUser },
    },
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
  });
}

export function saveEventUsers(csv, eventId) {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/events/${eventId}/users/import`,
    data: csv,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((response) => response.data);
}

export function fetchScuInformation({ eventId }) {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/events/scu-information/${eventId}`,
    method: 'GET',
  }).then((response) => response.data);
}

export function fetchEventMails({ eventId }) {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/event-mails/${eventId}`,
    method: 'GET',
  }).then((response) => response.data);
}

export function sendEventMail({ mailId, userMail }) {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/event-mails/send`,
    method: 'POST',
    data: {
      mail_id: mailId,
      user_mail: userMail,
    },
  }).then((response) => response.data);
}

export function saveEventMailTemplate({
  eventId, type, subject, scheduledAt, mailId,
}) {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/event-mails/${eventId}`,
    method: 'POST',
    data: {
      type,
      ...(subject !== undefined && { subject }),
      scheduled_at: scheduledAt,
      ...(mailId !== undefined ? { mail_id: mailId } : { mail_id: undefined }),
    },
  }).then((response) => response.data);
}

export function deleteEventMail({ eventId, mailId }) {
  return axios({
    url: `${EVENTS_PLATFORM_API_URL}/event-mails/${eventId}`,
    method: 'DELETE',
    data: {
      mail_id: mailId,
    },
  }).then((response) => response.data);
}
